import { forwardRef, Ref } from 'react';

interface DefaultIconProps {
  color?: string;
  className?: string;
}

export const HoverIcon = forwardRef(
  ({ color = '#EA40B9', className }: DefaultIconProps, ref: Ref<any>) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        ref={ref}
      >
        <path
          d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1Z"
          fill={color}
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M9.5 8C10.0523 8 10.5 7.55228 10.5 7C10.5 6.44772 10.0523 6 9.5 6C8.94772 6 8.5 6.44772 8.5 7C8.5 7.55228 8.94772 8 9.5 8Z"
          fill="white"
        />
        <path
          d="M14.5 8C15.0523 8 15.5 7.55228 15.5 7C15.5 6.44772 15.0523 6 14.5 6C13.9477 6 13.5 6.44772 13.5 7C13.5 7.55228 13.9477 8 14.5 8Z"
          fill="white"
        />
        <path
          d="M9.5 13C10.0523 13 10.5 12.5523 10.5 12C10.5 11.4477 10.0523 11 9.5 11C8.94772 11 8.5 11.4477 8.5 12C8.5 12.5523 8.94772 13 9.5 13Z"
          fill="white"
        />
        <path
          d="M14.5 13C15.0523 13 15.5 12.5523 15.5 12C15.5 11.4477 15.0523 11 14.5 11C13.9477 11 13.5 11.4477 13.5 12C13.5 12.5523 13.9477 13 14.5 13Z"
          fill="white"
        />
        <path
          d="M9.5 18C10.0523 18 10.5 17.5523 10.5 17C10.5 16.4477 10.0523 16 9.5 16C8.94772 16 8.5 16.4477 8.5 17C8.5 17.5523 8.94772 18 9.5 18Z"
          fill="white"
        />
        <path
          d="M14.5 18C15.0523 18 15.5 17.5523 15.5 17C15.5 16.4477 15.0523 16 14.5 16C13.9477 16 13.5 16.4477 13.5 17C13.5 17.5523 13.9477 18 14.5 18Z"
          fill="white"
        />
      </svg>
    );
  },
);
